import { COLORS } from '@btime/constants'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useOpenDynamicServiceOrdersModal } from '../../../../../utils/routes/modals/modalsActions'
import { useRemoveDynamicServiceOrders } from '../../_requests/removeDynamicServiceOrders'
import { useOpenShareDynamicServiceOrder } from '../../share/_context/ShareDynamicServiceOrderContext'
import { useSessionPermission } from '@btime/react-session'
import { appendIf } from '@btime/helpers'

export const useRowsActions = (item, ids) => {
  const openShareModal = useOpenShareDynamicServiceOrder()
  const openDynamicServiceOrdersModal = useOpenDynamicServiceOrdersModal()
  const [deleteItems] = useRemoveDynamicServiceOrders()
  const { t } = useTranslation('common')

  let canEdit = useSessionPermission('editDynamicServiceOrder')
  let canDelete = useSessionPermission('deleteDynamicServiceOrder')

  const singleOptions = useMemo(
    () => [
      {
        value: t('share'),
        icon: 'BsLink45Deg',
        onClick: () => openShareModal(item)
      },

      ...appendIf(canEdit, {
        value: t('edit'),
        icon: 'BsPencil',
        onClick: () => openDynamicServiceOrdersModal(item)
      }),

      ...appendIf(canDelete, {
        value: t('remove'),
        color: COLORS.red,
        icon: 'BsTrash',
        onClick: () => deleteItems([item.id])
      })
    ],
    [item, deleteItems, openShareModal, openDynamicServiceOrdersModal, t]
  )

  const multiOptions = useMemo(
    () => [
      {
        value: t('remove'),
        color: COLORS.red,
        icon: 'BsTrash',
        onClick: () => deleteItems(ids)
      }
    ],
    [ids, deleteItems, t]
  )

  return [!ids || ids.length === 1 ? singleOptions : multiOptions, false]
}
